import React, { useEffect, useState } from 'react';
// javascipt plugin for creating charts
import Chart from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
import { map, toNumber, isEmpty } from 'lodash-es';
import { Spinner } from 'reactstrap';
import { chartOptions, parseOptions } from '../../../variables/charts';
import {
  useGeneralHostAnalyticsByChargerId,
  useGeneralHostAnalyticsByChargerIdMonthly,
  useGeneralHostAnalyticsByChargerIdYearly,
} from '../../../utils/queries/hostQueries';
import ChartDataLabels from 'chartjs-plugin-datalabels';
parseOptions(Chart, chartOptions());
Chart.plugins.register(ChartDataLabels);

export default function EnergyDeliveredBarChartByGranularity({
  cpid,
  granularity,
  handleBarClick,
}) {
  const {
    data: dailyData,
    isLoading,
    error,
  } = useGeneralHostAnalyticsByChargerId(cpid);
  const { data: monthlyData } = useGeneralHostAnalyticsByChargerIdMonthly(cpid);
  const { data: yearlyData } = useGeneralHostAnalyticsByChargerIdYearly(cpid);

  let data = dailyData;

  if (granularity === 'monthly') {
    data = monthlyData;
  }
  if (granularity === 'yearly') {
    data = yearlyData;
  }
  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }
  const [selectedBarIndex, setSelectedBarIndex] = useState(-1);
  useEffect(() => {
    setSelectedBarIndex(-1);
  }, [granularity]);
  const defaultBarColor = '#fb6340';
  const selectedBarColor = '#414141';
  let chartData = {
    options: {
      scales: {
        yAxes: [
          {
            display: false,
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
      layout: {
        padding: {
          top: 50,
        },
      },
      onClick: (evt, ele) => {
        handleBarClick(granularity, data[ele[0]?._index]?.DATE);
        setSelectedBarIndex(ele[0]?._index);
      },
    },
    plugins: [ChartDataLabels],
    data: {
      labels: map(data, (row) => {
        return row.DATE;
      }),
      datasets: [
        {
          label: 'Energy Delivered',
          data: map(data, (row) => {
            return toNumber(row.KWH);
          }),
          backgroundColor: map(data, (row, index) =>
            index === selectedBarIndex ? selectedBarColor : defaultBarColor,
          ),
          maxBarThickness: 10,
          datalabels: {
            font: {
              weight: 400,
              size: '12',
            },
            color: 'black',
            backgroundColor: 'transparent',
            align: 'start',
            anchor: 'end',
            clamp: true,
            offset: -25,
            borderRadius: 5,
            padding: 4,
            opacity: 0.8,
            textAlign: 'center',
            formatter: function (value, context) {
              return `${value ? toNumber(value).toFixed(2) : value} kWh`;
            },
            listeners: {
              click: (context) => {
                handleBarClick(granularity, data[context.dataIndex]?.DATE);
              },
            },
          },
        },
      ],
    },
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '400px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#5e72e4' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : isEmpty(data) ? (
          'We dont have any Analytics report'
        ) : (
          <Bar data={chartData.data} options={chartData.options} />
        )}
      </div>
    </>
  );
}
